module.exports = [{"type":"title","text":"2026-01-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續合約相關：OpenAPI 已支援非數幣交易對。非數幣支援的交易對可透過介面 /openApi/swap/v2/quote/contracts 查詢。"}]},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Agent API：每日佣金明細接口已由 v1 升級至 v2。請使用 GET /openApi/agent/v2/reward/commissionDataList 以獲取更完整的每日佣金明細資料。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2026-01-22.json
// module id = Bn4Z
// module chunks = 3